module.exports = __webpack_public_path__ + "media/images/drop-down-489d74d69a40ae5b0629217da897f66e.png";